import { Spacing } from "@p0security/ui";

export const LimitedUse: React.FC<object> = () => (
  <Spacing asChild mt="2em">
    <div className="max-w-[800px] text-[small] text-[#999]">
      P0&apos;s use and transfer to any other app of information received from
      Google APIs will adhere to{" "}
      <a
        href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes"
        target="_blank"
        rel="noreferrer"
      >
        Google API Services User Data Policy
      </a>
      , including the Limited Use requirements.
    </div>
  </Spacing>
);
